import { Injectable } from '@angular/core'
import { Router, NavigationEnd } from '@angular/router'
import { BehaviorSubject, Observable } from 'rxjs'
import { filter } from 'rxjs/operators'

@Injectable({
  providedIn: 'root',
})
export class ClientContextService {
  private clientIdSubject = new BehaviorSubject<string | null>(null)
  public clientId$: Observable<string | null> = this.clientIdSubject.asObservable()

  constructor(private router: Router) {
    // Listen to route changes and extract clientId if present
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      const clientId = this.extractClientIdFromUrl()
      this.setClientId(clientId)
    })

    // Initial extraction
    const clientId = this.extractClientIdFromUrl()
    if (clientId) {
      this.setClientId(clientId)
    }
  }

  get clientId(): string | null {
    return this.clientIdSubject.value
  }

  get hasClientContext(): boolean {
    return this.clientId !== null
  }

  setClientId(clientId: string | null): void {
    this.clientIdSubject.next(clientId)

    if (clientId) {
      localStorage.setItem('current_client_id', clientId)
      localStorage.setItem('is_org_user', 'true')
    } else {
      localStorage.removeItem('current_client_id')
      localStorage.removeItem('is_org_user')
    }
  }

  clearClientId(): void {
    this.setClientId(null)
  }

  /**
   * Extract client ID from URL if present
   * Pattern: /org/:clientId/...
   */
  private extractClientIdFromUrl(): string | null {
    const url = this.router.url
    const orgMatch = url.match(/^\/org\/([^/]+)/)
    return orgMatch ? orgMatch[1] : null
  }

  /**
   * Check if user previously logged in as org user
   */
  isOrgUser(): boolean {
    return localStorage.getItem('is_org_user') === 'true'
  }

  /**
   * Get the stored client ID (for redirect after logout)
   */
  getStoredClientId(): string | null {
    return localStorage.getItem('current_client_id')
  }
}
